import { render } from "./communication_center_modal.vue?vue&type=template&id=46ca97a8"
import script from "./communication_center_modal.vue?vue&type=script&lang=js"
export * from "./communication_center_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__